import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@/configuration/setup/store';

export const FEATURE_SLICE_NAME = 'featureToggle';

export const FT_CBP_HISTORY_GRAPH = 'enable_cbp_history_graph';
export const FT_BBP_HISTORY_GRAPH = 'enable_bbp_history_graph';
export const FT_CBP_HISTORICAL_BATTERY_CONDITIONS = 'ft_cbp_historical_battery_conditions';
export const FT_BBP_HISTORICAL_BATTERY_CONDITIONS = 'ft_bbp_historical_battery_conditions';

const CURRENT_TOGGLES = [
    FT_CBP_HISTORY_GRAPH,
    FT_BBP_HISTORY_GRAPH,
    FT_CBP_HISTORICAL_BATTERY_CONDITIONS,
    FT_BBP_HISTORICAL_BATTERY_CONDITIONS,
] as const;

type KnownToggles = TypeFromArray<typeof CURRENT_TOGGLES>;

/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/no-shadow */
type TypeFromArray<T extends readonly unknown[]> = T extends readonly (infer TypeFromArray)[] ? TypeFromArray : never;

type EventContent = {
    featureKey: KnownToggles;
    value: string | undefined;
};

export type FeatureToggleState = {
    features: {
        [key in KnownToggles]: boolean;
    };
};

const initialState: FeatureToggleState = {
    features: {
        [FT_CBP_HISTORY_GRAPH]: false,
        [FT_BBP_HISTORY_GRAPH]: false,
        [FT_CBP_HISTORICAL_BATTERY_CONDITIONS]: false,
        [FT_BBP_HISTORICAL_BATTERY_CONDITIONS]: false,
    },
};

const featureToggleSlice = createSlice({
    initialState,
    name: FEATURE_SLICE_NAME,
    reducers: {
        featureToggleChanged: (state: FeatureToggleState, action: PayloadAction<EventContent>) => {
            const { featureKey, value } = action.payload;
            if (CURRENT_TOGGLES.includes(featureKey)) {
                state.features[featureKey] = value !== undefined ? /true/i.test(value) : false;
            }
        },
    },
});

// This is a selector, needs to be used with useAppSelector hook
export const isFeatureEnabled = (feature: KnownToggles) => (state: RootState) =>
    state[FEATURE_SLICE_NAME].features[feature];

export const { featureToggleChanged } = featureToggleSlice.actions;
export default featureToggleSlice.reducer;
